export { default } from './NoSsr';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/NoSsr/index.js
// module id = 592
// module chunks = 121